import Layout from '../layout/components/mainbox.vue'
import store from '@/store/index.js'
import Vue from 'vue'
import recom from '../layout/components/recom.vue'

// 转component字段的字符串为import
export function changeroute(routers) {
	let routerTree = []
	routerTree = assembleroute(routers,1).routerTree
	sessionStorage.setItem('routestext',JSON.stringify(routerTree))
	//已完成组装 改变vuex状态
	store.commit('routestatus', 1)
	return routerTree
}

// 递归组装路由
function assembleroute (routers,type){
	let routerTree = []
	let plugin = []
	
	routers.forEach(item=>{
		console.log('Processing route:', item.path, item.name, item.component);
		let obj = {
			path: item.path,
			name: item.vue_name,
			meta:{
				title:item.name,
				layout:item.layout,
				router_name:item.router_name,
				icon:item.icon,
				notright:item.notright,
				keep:item.keep_alive,
				// keepAlive:true,
				level:type,
			}
		}
		
		if(item.props){
			obj.meta.props = item.props
		}
		
		if(item.component == 'Layout' || item.component == '1'){
			Vue.set(obj, 'component', recom)
		}else{
			// 去除路径中的 ./ 前缀和开头的 /
			let componentPath = item.component.replace(/^\.\//, '').replace(/^\//, '');
			// 去除末尾的 .vue 后缀（require 会自动添加）
			if (componentPath.endsWith('.vue')) {
				componentPath = componentPath.slice(0, -4);
			}
			console.log('Original component path:', item.component);
			console.log('After trim:', componentPath);
			
			// 修复后端配置的路径：apps/weishop/shop/application/inventory -> apps/weishop/application/inventory
			if (componentPath.startsWith('apps/weishop/shop/application/inventory/')) {
				componentPath = componentPath.replace('apps/weishop/shop/application/inventory/', 'apps/weishop/application/inventory/');
				console.log('Fixed path (apps/weishop/shop -> apps/weishop):', componentPath);
			}
			// 修复后端配置的路径：weishop/shop/application/inventory -> apps/weishop/application/inventory
			if (componentPath.startsWith('weishop/shop/application/inventory/')) {
				componentPath = 'apps/' + componentPath.replace('weishop/shop/application/inventory/', 'weishop/application/inventory/');
				console.log('Fixed path (weishop/shop -> apps/weishop):', componentPath);
			}
			// 修复后端配置错误的组件路径：singGift -> competition/gift
			if (componentPath.includes('singGift')) {
				componentPath = componentPath.replace('singGift/list', 'competition/gift');
				console.log('Fixed path (singGift):', componentPath);
			}
			// 修复选手列表路径
			if (componentPath.includes('sign/list')) {
				componentPath = 'apps/weishop/application/sign/list';
				console.log('Fixed path (sign/list):', componentPath);
			}
			// 修复供应商端路径：weishop/supplier -> apps/weishop/supplier
			if (componentPath.startsWith('weishop/supplier/')) {
				componentPath = 'apps/' + componentPath;
				console.log('Fixed path (weishop/supplier):', componentPath);
			}
			// 修复进销存路径：weishop/application/inventory -> apps/weishop/application/inventory
			if (componentPath.startsWith('weishop/application/inventory/')) {
				componentPath = 'apps/' + componentPath;
				console.log('Fixed path (weishop/application/inventory):', componentPath);
			}
			// 修复商品导入路径：weishop/application/goodsimport -> apps/weishop/application/goodsimport
			if (componentPath.startsWith('weishop/application/goodsimport/')) {
				componentPath = 'apps/' + componentPath;
				console.log('Fixed path (weishop/application/goodsimport):', componentPath);
			}
			// 修复生日营销路径：weishop/application/birthday -> apps/weishop/application/birthday
			if (componentPath.startsWith('weishop/application/birthday/')) {
				componentPath = 'apps/' + componentPath;
				console.log('Fixed path (weishop/application/birthday):', componentPath);
			}
			// 修复其他 weishop/application 下的路径（如果没有 apps 前缀）
			if (componentPath.startsWith('weishop/application/') && !componentPath.startsWith('apps/')) {
				componentPath = 'apps/' + componentPath;
				console.log('Fixed path (weishop/application):', componentPath);
			}
			
			console.log('Final component path:', componentPath);
			Vue.set(obj, 'component', (resolve) => require([`@/views/${componentPath}`],resolve))
		}
		
		if(item._child&&item._child.length>0){
			obj.children = assembleroute(item._child,type+1).routerTree
			obj.plugin = assembleroute(item._child,type+1).plugin
		}
		
		if(item.app_level==0||item.app_level==2){
			routerTree.push(obj)
		}else{
			plugin.push(obj)
		}
	})

	return {
		'routerTree':routerTree,
		'plugin':plugin
	} 
}